import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import TableHelper from 'src/utils/table-helper';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import {
    asyncRequest,
    Entities,
    fetchById,
    getEntities,
    getUpdatedEntity,
    patch,
    save,
    search,
    TOMCAT_URL,
} from 'src/common';
import { setSliderIndex } from 'src/actions/form';

class FindMyBusRequestsCompanyTable extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper({
            onRowClick: this.onRowClick,
            pageSize: 100,
        });
    }

    render() {
        const { companies, t } = this.props;
        const tableData = [];
        for (const company of companies) {
            tableData.push({
                id: company.company.id,
                name: company.company.name,
                street: company.company.street,
                postCode: company.company.postCode,
                email: company.company.email,
                availableBuses: company.availableBuses,
            });
        }
        return (
            <div className="react-bs-table-find-my-bus">
                <BootstrapTableErrorBoundary>
                    <BootstrapTable
                        tableContainerClass="react-bs-table-find-my-bus"
                        style={{ height: '200px' }}
                        data={tableData}
                        striped={true}
                        hover={true}
                        exportCSV={false}
                        condensed={true}
                        pagination={false}
                        options={{ tableStyle: { height: '200px', overflowY: 'auto' } }}
                        selectRow={Object.assign({}, this.tableHelper.getRowProps())}>
                        <TableHeaderColumn columnTitle={true} dataField="id" hidden={true} isKey={true} export={true}>
                            {t('common_phrases.id')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} width="80" dataField="name" dataSort={true}>
                            Name
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} width="80" dataField="email" dataSort={true}>
                            {t('search_requests.email')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} width="80" dataField="street" dataSort={true}>
                            {t('contact_data.street')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} width="25" dataField="postCode" dataSort={true}>
                            {t('contact_data.post_code')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} width="80" dataField="availableBuses" dataSort={true}>
                            {t('find_my_bus.available_buses')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="actions"
                            width="60"
                            dataFormat={this.tableActionsFormatter}
                            export={false}>
                            {t('common_phrases.actions')}
                        </TableHeaderColumn>
                    </BootstrapTable>
                </BootstrapTableErrorBoundary>
            </div>
        );
    }

    tableActionsFormatter(cell, request) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title="Anfrage an Operator schicken"
                    onClick={() => {
                        this.getEmail(request);
                    }}>
                    <span className="glyphicon glyphicon-envelope text-info" />
                </button>
            </div>
        );
    }
    getEmail(request) {
        asyncRequest({
            endpoint: `${TOMCAT_URL}api/${Entities.FIND_MY_BUS_REQUEST.repository}/get-request-email?findMyBusId=${this.props.taskInfo.id}&companyId=${request.id}`,
        })
            .then(response => {
                const mailtoLink = `mailto:${request.email}?subject=${encodeURIComponent('Anfrage Bus')}&body=${encodeURIComponent(response.json.text)}`;
                window.open(mailtoLink);
            })
            .catch(error => {
                console.log('Error', error);
            });
    }
}

const mapStateToProps = (state, ownProps) => {
    const { isTripCompany } = ownProps;
    const entity = isTripCompany ? Entities.TRIP_COMPANY : Entities.BUS_COMPANY;

    return {
        company: getUpdatedEntity(state, entity),
        tripCategories: getEntities(state, Entities.TRIP_CATEGORY),
        tripAttributes: getEntities(state, Entities.TRIP_ATTRIBUTE),
        selectedSliderIndex: state.selectedSliderIndex,
    };
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        search,
        patch,
        save,
        setSliderIndex,
    },
    null,
    { withRef: true },
)(FindMyBusRequestsCompanyTable);
